export function checkIdCard(idCardNumber) {
  idCardNumber = idCardNumber.trim();
  if (!/^\d{17}[\dXx]$/.test(idCardNumber)) {
    return false;
  }
  const birthday = idCardNumber.substr(6, 8).replace(/(.{4})(.{2})/, '$1-$2-');
  const d = new Date(birthday);
  if (birthday !== (d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2))) {
    return false;
  }
  const coefficientArray = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const remainderArray = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
  const idArray = idCardNumber.split('');
  let sum = 0;
  for (let i = 0; i < 17; i++) {
    sum += idArray[i] * coefficientArray[i];
  }
  const remainder = sum % 11;
  const checkCode = remainderArray[remainder];
  return checkCode === idCardNumber.charAt(17).toUpperCase();
}

export function openLink(url, isBlank = false) {
  const link = document.createElement('a');
  let linkUrl = url;
  link.href = linkUrl;
  if (isBlank) {
    link.target = '_blank';
  }
  link.click();
  link.remove();
}

export function getFullImageUrl(path) {
  if (!path) return '';
  return `https://www.91eyou.com${path}`;
}

export const waitTime = (time = 100) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export function truncateText(text, maxLength) {
  if (text && text.length > maxLength) {
    return text.slice(0, maxLength) + '...';
  }
  return text;
}